<!--登录-->
<template>
  <div class="main">
    <div class="info-box">
      <div class="top-line"></div>
      <div class="info-content">
        <div class="title">请使用长江云账户登录</div>
        <Form class="form-box" ref="loginFromRef" :model="loginFrom" :rules="loginFromRules" inline>
          <Form-item prop="tel">
            <Input type="text" v-model="loginFrom.tel" @on-keyup="inputKeyUp(loginFrom.tel)" placeholder="请输入手机号">
              <i class="iconfont iconshouji1" slot="prepend"></i>
            </Input>
          </Form-item>
          <Form-item prop="captcha">
            <Input class="captchaInput" type="text" v-model="loginFrom.captcha" placeholder="请输入图形验证码">
              <Icon class="captcha" type="ios-lock-outline" slot="prepend"/>
              <div class="captchaImg" slot="append" @click="updataCaptchImg">
                <img :src="captchaData.img" alt="" v-if="isImg">
                <Icon class="imgNone" type="ios-image-outline" v-else/>
              </div>
            </Input>
          </Form-item>
          <Form-item prop="code">
            <Input class="yzm" type="text" v-model="loginFrom.code" placeholder="请输入验证码">
              <i class="iconfont iconyanzheng" slot="prepend"></i>
              <div class="btn" slot="append" v-show="show" @click="getCode">
                <i class="iconfont iconxiaoxi1"></i>
                <span>获取验证码</span>
              </div>
              <div class="btn" slot="append" v-show="!show">{{ count }}S后重新获取</div>
            </Input>
          </Form-item>
          <Form-item>
            <div class="submitBtn" @click="handleSubmit('loginFromRef')">登 录</div>
          </Form-item>
        </Form>
      </div>
    </div>
    <div class="info-btn"></div>
    <img class="login-user" src="../../assets/images/login_r.png" alt="" v-if="isRenBj">
    <Modal
        title="提示"
        width="100"
        v-model="modal"
        :mask-closable="false"
        :closable="false"
        class-name="vertical-center-modal">
      <p><i class="iconfont icontishi"></i>{{ modalText }}</p>
    </Modal>
  </div>
</template>

<script>
import {
  mobileCode,
  mobileLogin,
  getCaptcha,
  checkCaptcha,
} from "../../api/Interface";

const TIME_COUNT = 60;
export default {
  name: "login",
  data() {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'));
      } else {
        const reg = /^1[3-9]\d{9}$/
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error('请输入正确的手机号'));
        }
      }
    };

    return {
      docmHeight: document.documentElement.clientHeight || document.body.clientHeight,
      showHeight: document.documentElement.clientHeight || document.body.clientHeight,
      isRenBj: true,
      show: true,
      count: '',
      timer: null,
      loginFrom: {
        tel: null,
        code: null,
        captcha: null
      },
      loginFromRules: {
        tel: [
          {validator: checkPhone, trigger: 'blur'}
        ],
        code: [
          {required: true, message: '请输入验证码', trigger: 'blur'},
          {max: 6, min: 6, message: '验证码错误', trigger: 'blur'}
        ],
        captcha: [
          {required: true, message: '请输入图形验证码', trigger: 'blur'},
        ]
      },
      onlyCode: '',
      modal: false,
      modal1: false,
      modalText: '',
      id: '',
      captchaData: {},
      isImg: false,
    }
  },
  mounted() {
    //监听事件
    window.onresize = () => {
      return (() => {
        this.showHeight = document.documentElement.clientHeight || document.body.clientHeight;
      })()
    }
    this.getCaptchaData()
  },
  created() {
    this.$store.commit('formId', this.$route.query.id)
    if (localStorage.getItem('Device-ID') === null) {
      localStorage.setItem('Device-ID', Math.random() * 100 + Date.parse(new Date()))
    }
  },
  methods: {
    // 获取验证码
    getCode() {
      if ((/^1[3-9]\d{9}$/.test(this.loginFrom.tel)) && this.loginFrom.captcha !== '' && this.loginFrom.captcha !== null) {
        let data = {
          mobile: this.loginFrom.tel,
          form_id: this.$route.query.id,
          key: this.captchaData.key,
          captcha: this.loginFrom.captcha
        }
        mobileCode(data).then(res => {
          if (res.state) {
            if (!this.timer) {
              this.count = TIME_COUNT;
              this.show = false;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
                } else {
                  this.show = true;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000)
            }
          } else {
            this.$Message.error(res.error);
            return false
          }
        }).catch(error => {
          console.log(error);
        })
      } else {
        if (!(/^1[3-9]\d{9}$/.test(this.loginFrom.tel))) {
          this.$Message.error('请先输入正确的手机号');
        } else if (this.loginFrom.captcha === '' || this.loginFrom.captcha === null) {
          this.$Message.error('请先输入图形验证码');
        }
      }
    },
    //登录按钮
    handleSubmit(ref) {
      this.$refs[ref].validate((valid) => {
        if (valid) {
          let data = {
            form_id: this.$route.query.id,
            mobile: this.loginFrom.tel,
            code: this.loginFrom.code
          }
          mobileLogin(data).then(res => {
            if (res.state) {
              this.$store.commit('isToken', this.$store.state.settingData.base.login_limit)
              sessionStorage.setItem('token', 'Bearer' + res.data.token)
              if (this.$store.state.settingData.exam && this.$store.state.settingData.exam.fields_need_switch) {
                //答题类型进入收集用户页
                this.$router.push('/user-info?id=' + this.$route.query.id)
              } else {
                //问卷类型直接进入问卷说明页
                this.$router.push('/explain?id=' + this.$route.query.id)
              }
            } else {
              this.$Message.error(res.error);
            }
          }).catch(error => {
            console.log(error);
          })
        } else {
          this.$Message.error('表单验证失败');
        }
      })
    },
    //获取图形验证码
    getCaptchaData() {
      getCaptcha().then(res => {
        if (res.state) {
          this.isImg = true
          this.captchaData = res.data
        } else {
          this.$Message.error('图形验证码获取失败')
        }
      }).catch(error => {
        console.log(error);
      })
    },
    //更新图形验证码
    updataCaptchImg() {
      this.getCaptchaData()
    },
  
    //限制电话输入框只能输入数字
    inputKeyUp(value) {
      this.loginFrom.tel = value = value.replace(/[^\d]/g, '')
    },
  },
  watch: {
    //监听显示高度
    showHeight: function () {
      if (this.docmHeight > this.showHeight) {
        //隐藏
        this.isRenBj = false
      } else {
        //显示
        this.isRenBj = true
      }
    },
  },
}
</script>

<style lang="scss" scoped>
/* pc */
@media screen and (min-width: 1100px) {
  html {
    font-size: 16px !important;
  }
}


.main {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  /*overflow: hidden;*/
  height: 100%;
  background: url("../../assets/images/bj_img.png") no-repeat center;
  background-size: cover;
  padding: 50px 10px 0 10px;

  .info-box {
    position: relative;
    z-index: 999;

    .top-line {
      height: 20px;
      background: #1a4bff;
      border: 4px solid #256eff;
      border-radius: 11px;
      box-shadow: 0 3px 6px 0 rgba(0, 53, 157, 0.62);
    }

    .info-content {
      height: 410px;
      background: url("../../assets/images/login_bj.png") no-repeat;
      padding: 20px 30px 0 30px;
      background-size: 100% 100%;
      margin-top: -23px;

      .title {
        font-size: 20px;
        color: #303133;
        text-align: center;
        font-weight: bold;
        height: 68px;
        line-height: 68px;
      }

      .form-box {
        height: calc(100% - 68px);
        padding-top: 45px;

        .ivu-form-item-error {
          /deep/ .ivu-input {

            &:focus {
              box-shadow: none;
              border-color: #ed4014 !important;
            }
          }
        }

        .btn {
          display: flex;
          color: #3559E0;
          align-items: center;
          font-size: 12px;
          border-left: 1px solid #D2D6EB;
          padding-left: 10px;

          .iconfont {
            font-size: 18px !important;
            margin-right: 5px;
          }
        }


        .ivu-form-item {
          width: 100%;
          margin-bottom: 35px;

          .ivu-input-group {
            height: 45px;

            /deep/ .ivu-input-group-prepend {
              background-color: transparent;
            }

            /deep/ .ivu-input {
              height: 45px;
              border-left: none !important;
              outline: none !important;
              -webkit-appearance: none; /*去除系统默认的样式*/
              -webkit-tap-highlight-color: rgba(0, 0, 0, 0); /* 点击高亮的颜色*/

              &:focus {
                box-shadow: none;
                border-color: #dcdee2;
              }
            }

            .iconfont {
              font-size: 22px;
            }

            /deep/ .ivu-input-group-append {
              background-color: transparent;
              border-left: none !important;
            }
          }

          .yzm {
            /deep/ .ivu-input {
              border-right: none !important;
            }
          }
        }
      }

      .submitBtn {
        width: 170px;
        height: 62px;
        display: block;
        border-radius: 18px;
        background: url("../../assets/images/btn_y.png") no-repeat;
        font-size: 20px;
        line-height: 62px;
        color: #fff;
        background-size: cover;
        text-align: center;
        margin: -10px auto 0 auto;
      }
    }
  }
}

.login-user {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 40%;
  z-index: 0;
}

/deep/ .ivu-modal {
  margin: 20% 50px;
}

/deep/ .ivu-modal-header {
  border-bottom: none;
}

/deep/ .ivu-modal-body {
  font-size: 16px;

  p {
    display: flex;
    align-items: center;

    .iconfont {
      color: #ee9900;
      font-size: 24px;
      margin-right: 5px;
    }
  }

}

/deep/ .ivu-modal-footer {
  display: none;
}

.modal1 {
  p {
    i {
      font-size: 20px;
      color: #ee9900;
      margin-right: 5px;
      font-weight: bold;
    }
  }
}

.captcha {
  font-size: 22px;
  font-weight: 500;
  color: #000;
}

.captchaImg {
  width: 70px;

  .imgNone {
    font-size: 28px;
  }

  img {
    width: 100%;
  }
}

/deep/ .captchaInput {
  .ivu-input {
    border-right: none !important;
  }
}

.downloadModal /deep/ .ivu-modal-footer {
  display: block;
  padding: 0px;
  height: 50px;

  > div {
    display: flex;
    align-items: center;
    height: 100%;
    text-align: center;
    line-height: 50px;

    > div {
      width: 50%;
      height: 100%;
    }
  }
}

.downloadModal /deep/ .ivu-modal-header {
  padding-bottom: 0px;
  color: #494949;;
}

</style>
